import { Resource, Signal } from '@angular/core';
import { Query } from '../../query/query.builder';

export interface GridServerSideDataSource<T extends object> {
  type: 'serverSide';
  load(query: Query): Promise<{data: Partial<T[]>}>;
}

export interface GridSSRMDataSource<T extends object> {
  type: 'ssrm';
  load(query: Query): Promise<{data: Partial<T[]>, pivotFields?: string[]}>;
}

export type GridDataSource<T extends object> = T[] | Signal<T[]> | Resource<T[] | undefined> | GridSSRMDataSource<T> | GridServerSideDataSource<T>;

export function isSSRMDataSource<T extends object>(dataSource: GridDataSource<T>): dataSource is GridSSRMDataSource<T> {
  return (dataSource as {type: string})?.type === 'ssrm';
}

export function isServerSideDataSource<T extends object>(dataSource: GridDataSource<T>): dataSource is GridServerSideDataSource<T> {
  return (dataSource as {type: string})?.type === 'serverSide';
}
